import script from "./VideoPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./VideoPreview.vue?vue&type=script&setup=true&lang=js"

import "./VideoPreview.vue?vue&type=style&index=0&id=ab654ad4&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab654ad4"]])

export default __exports__